<template>
  <div class="about">
    <h1>don't do it</h1>
    <img alt="thanos-ms" src="../assets/thanos.png" />
  </div>
</template>
